import { useNavigate } from 'react-router-dom'
import whowe1 from '../../assets/whowe-1.avif'
import whowe2 from '../../assets/whowe-2.avif'
import whowe3 from '../../assets/whowe-3.svg'

export default function Whowe() {

    let contents = [{
        image: whowe1,
        topic: 'Product-First Engineering',
        cotent: 'SAN Technovation is a Product + IT Services company crafting intelligent platforms for modern enterprises.'
    },
    {
        image: whowe2,
        topic: 'Clarity Through Intelligence',
        cotent: 'We help businesses turn complexity into clarity through AI-powered systems, scalable software platforms.'
    },
    {
        image: whowe3,
        topic: 'Built for What’s Next',
        cotent: 'From intelligent automation to IoT monitoring systems, we deliver solutions that drive business value.'
        }]
    const navigate = useNavigate()
    return (
        <section className="py-8 bg-secondary-50 px-4 sm:px-6 md:px-12 lg:px-24 my-6">
            <div className="mx-auto max-w-7xl px-6">

                <span className="inline-block text-secondary-500 text-sm sm:text-base py-2 px-4 bg-white rounded-full">
                    Who We Are
                </span>

                <h2 className="font-bold text-2xl sm:text-3xl lg:text-4xl mt-6">
                    Building Smart Digital Ecosystems
                </h2>

                {/* Cards */}
                <div className="flex lg:flex-nowrap flex-wrap  gap-5 mt-8">
                    {contents.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-xl p-5 hover:shadow-lg transition duration-300 max-w-[384px]"
                        >
                            <img
                                src={item.image}
                                alt={item.topic}
                                className="w-full h-48 object-cover rounded-lg"
                                onContextMenu={(e) => e.preventDefault()}
                                draggable={false}
                            />

                            <h5 className="text-black font-medium text-lg sm:text-xl py-3">
                                {item.topic}
                            </h5>

                            <p className="font-secondary text-gray-500 text-sm sm:text-base leading-relaxed">
                                {item.cotent}
                            </p>
                        </div>
                    ))}
                </div>

                <p className="my-8 text-center text-black font-medium text-sm sm:text-base px-4">
                    If you’re looking for a partner who thinks beyond execution — you’ve just found one.
                </p>

                <div className="text-center">
                    <button className="text-secondary-500 font-semibold text-base py-2.5 px-6 bg-white rounded-2xl border border-secondary-500 hover:bg-secondary-500 hover:text-white transition duration-700"
                        onClick={() => navigate('/about')}>
                        Learn More
                    </button>
                </div>

            </div>
        </section>

        
    )
}
